import cx from "classnames";
import styles from "./style.module.scss";
import { FormGroup, Input, Label } from "reactstrap";

const RadioInput = (props) => {
  const { className, inputProps, onChange, value, isHorizontal = false, inputErrors = false,
    isDisabled, id, options = [] } = props;


  const triggerOnChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  }

  const renderRadioButtons = () => {
    return options.map(o => {
      const radioId = `${id}-${inputProps.name}-${o.value}`;
      return (
        <FormGroup check>
          <Input
            id={radioId}
            name={`${inputProps.name}`}
            type="radio"
            value={o.value}
            checked={o.value == value}
            onClick={(e) => triggerOnChange(e)}
            isDisabled={isDisabled}
          />
          {' '}
          <Label for={radioId} check>
            {o.label}
          </Label>
        </FormGroup>
      )
    })
  }

  return (
    <div className={styles.selectDropdown}>
      <div
        className={cx(
          {
            "is-invalid form-control": inputErrors,
            [styles.errorPadding]: inputErrors,
            [styles.horizontalOptions]: isHorizontal,
            className: className
          }
        )}
      >
        {renderRadioButtons()}
      </div>

      {inputErrors}
    </div>
  );
}

export default RadioInput;